import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

import { CreditSubscription, CreditSubscriptionData, processSubscriptionData } from '@/models/CreditSubscription';
import { monolithApi } from '@/utils/api';

export const CreditSubscriptionQueryKey = 'credit-subscription';

export const creditSubscriptionQueryKey = (accountSlug: string) => [CreditSubscriptionQueryKey, accountSlug];

type CreditAccount = { slug: string };

const useCreditSubscription = (
  acc: CreditAccount,
  options?: Omit<UseQueryOptions<CreditSubscription>, 'queryKey' | 'queryFn'>,
): UseQueryResult<CreditSubscription> =>
  useQuery({
    queryKey: creditSubscriptionQueryKey(acc.slug),
    queryFn: async () => {
      const url = `/organization/${acc.slug}/payment_subscription_status`;
      const { data } = await monolithApi.get<CreditSubscriptionData>(url);
      return processSubscriptionData(data);
    },

    ...options,
  });

export default useCreditSubscription;
